export interface Article {
  id: number;
  slug: string;
  category: string;
  categoryColor: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  image: string;
  url: string;
}

export const articles: Article[] = [
  {
    id: 1,
    slug: 'porte-claquee-que-faire',
    category: 'Serrurerie',
    categoryColor: 'bg-yellow-400 text-[#1a1a1a]',
    title: 'Porte claquée : que faire en urgence ?',
    excerpt: 'Vous venez de claquer votre porte et vos clés sont à l\'intérieur ? Pas de panique. Voici les bons réflexes à adopter avant d\'appeler un serrurier d\'urgence à Paris.',
    date: '15 mars 2025',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=close%20up%20of%20a%20locked%20door%20handle%20and%20keyhole%20in%20a%20parisian%20apartment%20building%20hallway%20with%20warm%20lighting%20and%20clean%20white%20walls&width=600&height=400&seq=art1&orientation=landscape',
    url: 'https://clevys.fr/blog/porte-claquee-que-faire',
  },
  {
    id: 2,
    slug: 'choisir-serrure-blindee',
    category: 'Sécurité',
    categoryColor: 'bg-red-500 text-white',
    title: 'Comment choisir sa serrure blindée en 2025 ?',
    excerpt: 'Certification A2P, multipoints, connectée… Le marché des serrures blindées est vaste. Notre guide complet pour choisir la protection adaptée à votre porte parisienne.',
    date: '2 mars 2025',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=modern%20high%20security%20door%20lock%20close%20up%20with%20metallic%20finish%20on%20a%20solid%20wooden%20door%20clean%20minimal%20background&width=600&height=400&seq=art2&orientation=landscape',
    url: 'https://clevys.fr/blog/choisir-serrure-blindee',
  },
  {
    id: 3,
    slug: 'fuite-eau-urgence-plombier',
    category: 'Plomberie',
    categoryColor: 'bg-blue-500 text-white',
    title: 'Fuite d\'eau : les gestes d\'urgence avant l\'arrivée du plombier',
    excerpt: 'Une fuite d\'eau peut causer des dégâts considérables en quelques minutes. Découvrez comment couper l\'eau, limiter les dégâts et quand appeler un plombier d\'urgence.',
    date: '18 février 2025',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=water%20pipe%20leak%20under%20kitchen%20sink%20with%20water%20drops%20and%20plumbing%20tools%20on%20white%20background%20clean%20minimal&width=600&height=400&seq=art3&orientation=landscape',
    url: 'https://clevys.fr/blog/fuite-eau-urgence-plombier',
  },
  {
    id: 4,
    slug: 'vitre-cassee-remplacement',
    category: 'Vitrerie',
    categoryColor: 'bg-green-500 text-white',
    title: 'Vitre cassée : remplacement rapide par un vitrier à Paris',
    excerpt: 'Effraction, accident ou intempérie… Une vitre cassée doit être remplacée rapidement pour sécuriser votre logement. Tout ce qu\'il faut savoir sur l\'intervention d\'un vitrier.',
    date: '5 février 2025',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=broken%20window%20glass%20replacement%20glazier%20working%20on%20a%20parisian%20apartment%20window%20with%20tools%20and%20new%20glass%20panel&width=600&height=400&seq=art4&orientation=landscape',
    url: 'https://clevys.fr/blog/vitre-cassee-remplacement',
  },
  {
    id: 5,
    slug: 'prevenir-cambriolage-conseils',
    category: 'Sécurité',
    categoryColor: 'bg-red-500 text-white',
    title: '10 conseils pour prévenir les cambriolages chez vous',
    excerpt: 'En France, un cambriolage a lieu toutes les 90 secondes. Serrures renforcées, alarmes, éclairage… Nos experts partagent leurs meilleures astuces pour sécuriser votre domicile.',
    date: '22 janvier 2025',
    readTime: '7 min',
    image: 'https://readdy.ai/api/search-image?query=secure%20home%20front%20door%20with%20reinforced%20lock%20and%20security%20camera%20in%20a%20parisian%20building%20entrance%20clean%20modern&width=600&height=400&seq=art5&orientation=landscape',
    url: 'https://clevys.fr/blog/prevenir-cambriolage-conseils',
  },
  {
    id: 6,
    slug: 'cylindre-serrure-changer',
    category: 'Serrurerie',
    categoryColor: 'bg-yellow-400 text-[#1a1a1a]',
    title: 'Quand et pourquoi changer le cylindre de sa serrure ?',
    excerpt: 'Déménagement, perte de clés, tentative d\'effraction… Il existe plusieurs situations où changer son cylindre est indispensable. On vous explique tout sur cette opération rapide et économique.',
    date: '10 janvier 2025',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=door%20cylinder%20lock%20replacement%20close%20up%20with%20locksmith%20tools%20on%20a%20wooden%20door%20bright%20clean%20background&width=600&height=400&seq=art6&orientation=landscape',
    url: 'https://clevys.fr/blog/cylindre-serrure-changer',
  },
  {
    id: 7,
    slug: 'double-vitrage-avantages',
    category: 'Vitrerie',
    categoryColor: 'bg-green-500 text-white',
    title: 'Double vitrage : avantages, coûts et installation à Paris',
    excerpt: 'Isolation thermique, phonique, économies d\'énergie… Le double vitrage est un investissement rentable. Découvrez tout ce qu\'il faut savoir avant de faire appel à un vitrier.',
    date: '28 décembre 2024',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=double%20glazed%20window%20installation%20in%20a%20modern%20parisian%20apartment%20with%20city%20view%20bright%20natural%20light%20clean%20interior&width=600&height=400&seq=art7&orientation=landscape',
    url: 'https://clevys.fr/blog/double-vitrage-avantages',
  },
  {
    id: 8,
    slug: 'debouchage-canalisation-urgence',
    category: 'Plomberie',
    categoryColor: 'bg-blue-500 text-white',
    title: 'Débouchage de canalisation : urgence ou intervention planifiée ?',
    excerpt: 'Évier bouché, WC obstrué, odeurs nauséabondes… Quand faut-il appeler un plombier en urgence ? Nos conseils pour distinguer le simple bouchon de l\'obstruction grave.',
    date: '15 décembre 2024',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=plumber%20working%20on%20clogged%20drain%20pipe%20under%20sink%20with%20professional%20tools%20clean%20bathroom%20background%20minimal&width=600&height=400&seq=art8&orientation=landscape',
    url: 'https://clevys.fr/blog/debouchage-canalisation-urgence',
  },
  {
    id: 9,
    slug: 'serrure-connectee-guide',
    category: 'Serrurerie',
    categoryColor: 'bg-yellow-400 text-[#1a1a1a]',
    title: 'Serrure connectée : guide complet pour bien choisir',
    excerpt: 'Bluetooth, Wi-Fi, code PIN, reconnaissance d\'empreinte… Les serrures connectées révolutionnent la sécurité à domicile. Notre comparatif des meilleures solutions du marché.',
    date: '1 décembre 2024',
    readTime: '8 min',
    image: 'https://readdy.ai/api/search-image?query=smart%20connected%20door%20lock%20with%20smartphone%20app%20control%20modern%20minimalist%20design%20on%20white%20door%20clean%20background&width=600&height=400&seq=art9&orientation=landscape',
    url: 'https://clevys.fr/blog/serrure-connectee-guide',
  },
  {
    id: 10,
    slug: 'urgence-plomberie-nuit',
    category: 'Plomberie',
    categoryColor: 'bg-blue-500 text-white',
    title: 'Plombier d\'urgence la nuit à Paris : comment ça marche ?',
    excerpt: 'Une canalisation qui éclate à 2h du matin, c\'est le cauchemar de tout propriétaire. Tarifs de nuit, délais d\'intervention, assurance… Ce que vous devez savoir sur les plombiers d\'urgence.',
    date: '18 novembre 2024',
    readTime: '5 min',
    image: 'https://readdy.ai/api/search-image?query=emergency%20plumber%20at%20night%20working%20on%20burst%20pipe%20in%20a%20parisian%20apartment%20with%20professional%20equipment%20dramatic%20lighting&width=600&height=400&seq=art10&orientation=landscape',
    url: 'https://clevys.fr/blog/urgence-plomberie-nuit',
  },
  {
    id: 11,
    slug: 'blindage-porte-paris',
    category: 'Sécurité',
    categoryColor: 'bg-red-500 text-white',
    title: 'Blindage de porte à Paris : prix, types et démarches assurance',
    excerpt: 'Le blindage de porte est la solution anti-effraction la plus efficace. Tôle acier, blindage parisien, porte de cave… Tout savoir sur les prix et la prise en charge par votre assurance.',
    date: '5 novembre 2024',
    readTime: '6 min',
    image: 'https://readdy.ai/api/search-image?query=armored%20reinforced%20door%20installation%20in%20parisian%20apartment%20building%20hallway%20with%20steel%20plating%20and%20security%20locks&width=600&height=400&seq=art11&orientation=landscape',
    url: 'https://clevys.fr/blog/blindage-porte-paris',
  },
  {
    id: 12,
    slug: 'vitrier-urgence-effraction',
    category: 'Vitrerie',
    categoryColor: 'bg-green-500 text-white',
    title: 'Vitrier d\'urgence après effraction : intervention rapide à Paris',
    excerpt: 'Après un cambriolage, sécuriser les ouvertures est une priorité absolue. Notre équipe de vitriers intervient en urgence 24h/24 pour remplacer vitres et vitrines dans tout Paris.',
    date: '22 octobre 2024',
    readTime: '4 min',
    image: 'https://readdy.ai/api/search-image?query=emergency%20glazier%20replacing%20broken%20window%20after%20burglary%20in%20paris%20apartment%20with%20tools%20and%20new%20glass%20panel%20professional&width=600&height=400&seq=art12&orientation=landscape',
    url: 'https://clevys.fr/blog/vitrier-urgence-effraction',
  },
];
